/**
* @see /client/components/GiftCardProduct/index.js
*/

import React from 'react';
import { shape, func, string } from 'prop-types';
import StyledTerms from './StyledTerms';
import { SHIPPING_TEXT, MANIPAL_SHIPPING_TEXT } from './constants';

function shippingInfo(product_type, sInfo) {
  let info = '';
  switch (product_type) {
    case 'merchandise':
      info = MANIPAL_SHIPPING_TEXT;
      break;
    case 'physical_voucher':
      info = sInfo || SHIPPING_TEXT;
      break;
    case 'evoucher':
      info = sInfo || info;
      break;
    default:
      info = SHIPPING_TEXT;
      break;
  }
  return info;
}
function Terms(props) {
  const {
    metadata: { description, how_it_works, how_to_redeem, shipping_info, product_type },
    onTabClick,
    activeTab,
  } = props;
  const dataObj = { description, how_it_works, how_to_redeem, shipping_info };
  return (
    <StyledTerms>
      {/* <span>
        <strong>Terms Conductions</strong><b>|</b><strong>Description</strong>
      </span> */}
      <ul className="terms">
        { product_type !== 'merchandise' ?
          <li className={activeTab === 'how_to_redeem' ? 'active' : ''} onClick={() => onTabClick('how_to_redeem')} role="presentation">Redemption Terms</li> : null
        }
        <li className={activeTab === 'description' ? 'active' : ''} onClick={() => onTabClick('description')} role="presentation">Description</li>
        {/* <li className={activeTab === 'how_it_works' ? 'active' : ''} onClick={() => onTabClick('how_it_works')}>How it works</li> */}
        {product_type !== 'evoucher' ?
          <li className={activeTab === 'shipping_info' ? 'active' : ''} onClick={() => onTabClick('shipping_info')} role="presentation">Shipping & Handling</li> : ''
        }
      </ul>
      {
        (activeTab === 'shipping_info') ? (
          <div
            className="content"
            dangerouslySetInnerHTML={{ __html: shippingInfo(product_type, shipping_info) }}
          />
        ) : (
          <div className="content" dangerouslySetInnerHTML={{ __html: dataObj[activeTab] }}></div>
        )
      }
      {/* <div className="content" dangerouslySetInnerHTML={{__html: dataObj[activeTab]}}></div> */}
    </StyledTerms>
  );
}
Terms.propTypes = {
  metadata: shape({}).isRequired,
  onTabClick: func.isRequired,
  activeTab: string.isRequired,
};

export default Terms;



// WEBPACK FOOTER //
// client/containers/GiftCardProduct/terms.js